import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { currencyFilter } from '@/utils/string'
import { getAmenityIconByKey } from '@/utils/amenity'
import { SalesBotAmenityOption } from "@/models/dto/SalesbotV2VehicleOptions"


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotAmenityOptionCard',
  props: {
    amenityOption: null,
    selected: { type: Boolean }
  },
  emits: ['toggle'],
  setup(__props: any, { emit }) {

const props = __props as {
  amenityOption: SalesBotAmenityOption,
  selected: boolean
};




const price = computed(() => {
  if (props.amenityOption.price === 0) return 'Free'
  return `${currencyFilter(props.amenityOption.price)} per vehicle`
})

const toggle = () => emit('toggle')

return { __sfc: true,props, emit, price, toggle, getAmenityIconByKey }
}

})